import { Injectable, NgZone } from '@angular/core';

import { Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Http } from '@angular/http';
import { ToastController } from 'ionic-angular';
import moment from 'moment';

@Injectable()
export class KontrollenModel {
  public kontid:number;
  public start : string;
  public fkuser : number;
  public fkgrund : number;
  public bemerkung : string = "";
  public startlongit : number;
  public startlatit:number;
  public ende : string;
  public endelongit:number;
  public endelatit:number;
  public beweis1:string;
  public beweis2:string;
  public beweis3:string;
  public beweis4:string;
  public beweis5:string;
  public beweis6:string;
  public beweis7:string;
  public beweis8:string;
  public beweis9:string;
  public beweis10:string;
  public anzautos:number;
  public info:string;
  public error:string;
  public additionalinfos: string[];

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/kontrollen/kontrollen-model.ts